(function () {
  const initialized = new WeakSet();
  let sharedInitialized = false;

  function normalizeLabel(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function initializeNavigation() {
    const isLandingPage = window.location.protocol === 'file:' || window.location.pathname === '/';
    const routes = {
      home: isLandingPage ? '#' : '/',
      'track record': isLandingPage ? '#track-record' : '/#track-record',
      membership: isLandingPage ? '#membership' : '/#membership',
      about: isLandingPage ? '#about' : '/#about',
      faq: isLandingPage ? '#faq' : '/#faq'
    };

    document.querySelectorAll('.header__inline-menu a, .menu-drawer__navigation a, .preview-nav a').forEach((link) => {
      const route = routes[normalizeLabel(link.textContent)];
      if (route) link.setAttribute('href', route);
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (href === '#') {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', href);
    });
  }

  function initializeClock() {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    const update = () => {
      const value = formatter.format(new Date()).replace(/\s/g, '') + ' PT';
      document.querySelectorAll('[data-vk-clock]').forEach((clock) => { clock.textContent = value; });
    };

    update();
    window.setInterval(update, 1000);
  }

  function playTerminalClick() {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;
    const context = new AudioContextClass();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const now = context.currentTime;
    oscillator.type = 'square';
    oscillator.frequency.setValueAtTime(920, now);
    oscillator.frequency.exponentialRampToValueAtTime(540, now + 0.035);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.035, now + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.05);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(now);
    oscillator.stop(now + 0.055);
    oscillator.addEventListener('ended', () => context.close());
  }

  function initializeAccessTriggers() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vk-access-trigger]');
      if (trigger) playTerminalClick();
    });

    document.querySelectorAll('[data-vk-access-trigger]').forEach((trigger) => {
      const hero = trigger.closest('.vk-hero');
      if (!hero) return;
      const activate = () => hero.classList.add('is-access-active');
      const deactivate = () => hero.classList.remove('is-access-active');
      trigger.addEventListener('pointerenter', activate);
      trigger.addEventListener('pointerleave', deactivate);
      trigger.addEventListener('focus', activate);
      trigger.addEventListener('blur', deactivate);
    });
  }

  function initializeBullMotion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.vk-hero').forEach((hero) => {
      if (hero.dataset.vkBullMotion === 'ready') return;
      hero.dataset.vkBullMotion = 'ready';
      const image = hero.querySelector('.vk-hero__image');
      if (!image) return;

      hero.addEventListener('pointermove', (event) => {
        const bounds = hero.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2;
        const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 2;
        image.style.setProperty('--vk-bull-x', `${x * 9}px`);
        image.style.setProperty('--vk-bull-y', `${y * 5}px`);
      }, { passive: true });

      hero.addEventListener('pointerleave', () => {
        image.style.setProperty('--vk-bull-x', '0px');
        image.style.setProperty('--vk-bull-y', '0px');
      });
    });
  }

  function initializeShared() {
    if (sharedInitialized) return;
    sharedInitialized = true;
    initializeNavigation();
    initializeClock();
    initializeAccessTriggers();
  }

  function initialize(scope) {
    if (!scope || initialized.has(scope)) return;
    initialized.add(scope);

    const revealItems = scope.querySelectorAll('[data-vk-reveal]');
    const paths = scope.querySelectorAll('[data-vk-draw]');

    paths.forEach((path) => {
      if (typeof path.getTotalLength !== 'function') return;
      const length = path.getTotalLength();
      path.style.strokeDasharray = String(length);
      path.style.strokeDashoffset = String(length);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      paths.forEach((path) => { path.style.strokeDashoffset = '0'; });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.querySelectorAll('[data-vk-draw]').forEach((path) => {
          path.style.transition = 'stroke-dashoffset 1.5s cubic-bezier(.22,.61,.36,1)';
          path.style.strokeDashoffset = '0';
        });
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    revealItems.forEach((item) => observer.observe(item));
  }

  function initializeAll(root) {
    initializeShared();
    initializeBullMotion();
    const scopes = root.matches && root.matches('.vk-ft') ? [root] : root.querySelectorAll('.vk-ft');
    scopes.forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
